import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useBaseUrl } from '../utils/utils';

/**
 * Login for InternalUser (tracker Phase 10.1/10.8) - the platform's 5th
 * principal type had no login page at all until this. Deliberately its own
 * simple opaque-token flow (`platform/login/`), not the JWT-based
 * `core/api/auth/login/` "modern auth" system Staff/Patient/Provider use -
 * that system only recognizes those three roles server-side
 * (uzima_core/auth_api_views.py), and there is no self-registration for
 * internal accounts to reconcile with it (they're created by a Super Admin,
 * see internal/superadmin/UserGrantAdmin.tsx), so there's nothing forcing
 * this onto the same rails.
 */

const InternalLogin: React.FC = () => {
    const baseUrl = useBaseUrl();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const submit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await axios.post(`${baseUrl}platform/login/`, { email, password });
            if (res.data?.status !== 'success') {
                throw new Error(res.data?.message || 'Login failed');
            }
            const { token } = res.data.data;
            localStorage.setItem('token', token);
            localStorage.setItem('authToken', token);
            navigate('/dashboards');
        } catch (err: any) {
            setError(err?.response?.data?.message || err.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #f8fafc 0%, #ecfdf9 100%)' }}>
            <div className="card shadow-sm" style={{ width: 400 }}>
                <div className="card-body p-4">
                    <h4 className="fw-bold mb-1">Uzima Internal</h4>
                    <p className="text-muted small mb-4">Platform staff sign-in - Support, Finance, Compliance, CRM, BizDev, HR and Super Admin dashboards.</p>
                    {error && <div className="alert alert-danger py-2">{error}</div>}
                    <form onSubmit={submit}>
                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input type="email" className="form-control" required value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Password</label>
                            <input type="password" className="form-control" required value={password} onChange={(e) => setPassword(e.target.value)} />
                        </div>
                        <button className="btn btn-primary w-100" type="submit" disabled={loading}>
                            {loading ? 'Signing in...' : 'Sign in'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default InternalLogin;
